import React, { useState, useEffect } from 'react';
import './AccountDetail.css';
import TicketList from './TicketList';
import ConsumptionChart from './ConsumptionChart';
import MeetingSummary from './MeetingSummary';

const AccountDetail = ({ account, accountKey, onBack, onActionToggle }) => {
  const [currentMeetingIndex, setCurrentMeetingIndex] = useState(0);

  useEffect(() => {
    // Reset to first meeting when account changes
    setCurrentMeetingIndex(0);
  }, [accountKey]);

  return (
    <div className="account-detail active">
      <div className="detail-header">
        <div className="header-content">
          <div className="account-info">
            <h2>{account.name}</h2>
            <span className={`health-score ${account.status}`}>
              Health Score: {account.healthScore}%
            </span>
          </div>
          <div className="contract-info">
            <div className="contract-row">
              <div className="contract-item">
                <span className="contract-label">Contract Start</span>
                <span className="contract-value">{account.contract.startDate}</span>
              </div>
              <div className="contract-item">
                <span className="contract-label">Duration</span>
                <span className="contract-value">{account.contract.duration}</span>
              </div>
              <div className="contract-item">
                <span className="contract-label">Current Year</span>
                <span className="contract-value">{account.contract.currentYear} of 3</span>
              </div>
            </div>
            <div className="contract-row">
              <div className="contract-item">
                <span className="contract-label">ARR Value</span>
                <span className="contract-value highlight">{account.contract.arrValue}</span>
              </div>
              <div className="contract-item">
                <span className="contract-label">Renewal Date</span>
                <span className="contract-value">{account.contract.renewalDate}</span>
              </div>
              <div className="contract-item">
                <span className="contract-label">Status</span>
                <span className={`contract-value status-${account.contract.status.toLowerCase().replace(/\s+/g, '-')}`}>
                  {account.contract.status}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="metric-card tickets-section">
        <h3>Support Tickets ({account.tickets.length})</h3>
        <TicketList tickets={account.tickets} />
      </div>

      <div className="products-grid single-product">
        <div className="product-card">
          <ConsumptionChart 
            consumption={account.consumption} 
            status={account.status}
            accountKey={accountKey}
            accountName={account.name}
            contract={account.contract}
          />
        </div>
      </div>

      <div className="summary-section">
        <h3>Account Summary</h3>
        <div className="summary-content">
          {account.summary}
        </div>
        
        <MeetingSummary 
          meetings={account.meetings}
          accountKey={accountKey}
          accountName={account.name}
          currentMeetingIndex={currentMeetingIndex}
          onMeetingSelect={setCurrentMeetingIndex}
          onActionToggle={onActionToggle}
        />
      </div>
    </div>
  );
};

export default AccountDetail;